import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "sortable",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
        //@ts-ignore
        (...args) => (_ctx.changeSort && _ctx.changeSort(...args)), ["prevent"]))
    }, [
        _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "default"),
            _cache[1] || (_cache[1] = _createTextVNode()),
            (_ctx.title)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.title), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
        ]),
        _cache[3] || (_cache[3] = _createTextVNode()),
        _createElementVNode("span", {
            class: _normalizeClass(_ctx.cssClass)
        }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", {
                    class: "sorted-up fa fa-caret-up",
                    "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(),
                _createElementVNode("i", {
                    class: "sorted-down fa fa-caret-down",
                    "aria-hidden": "true"
                }, null, -1 /* CACHED */)
            ]))], 2 /* CLASS */)
    ]));
}
